import { Grid, Paper, Typography } from '@mui/material';
import { RouterLink } from 'main/components/_common/RouterLink';

export const Notification = () => {
    return (
        <Paper sx={{ backgroundColor: 'rgb(253, 237, 237)', marginX: 2, padding: 2 }}>
            <Grid container direction="column">
                <Grid item container justifyContent="center">
                    <Typography variant="h6">お知らせ</Typography>
                </Grid>
                <Grid item>
                    <Typography>天候、大会等により、スケジュールが変更される場合があります。</Typography>
                </Grid>
                <Grid item>
                    <Typography>
                        <span>体験、見学希望の方は、必ず事前に</span>
                        <RouterLink path="/contact">お問い合わせ</RouterLink>
                        <span>をお願いします。</span>
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    )
}
